const Footer=()=>{
    return(
        <footer className="page-footer">
            <p className="mb-0">Copyright © 2025. All right reserved.</p>
        </footer>
    );

}
export default Footer;
